var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00008 13.2712C3.54092 13.2712 0.729248 10.4595 0.729248 7.00033C0.729248 3.54116 3.54092 0.729492 7.00008 0.729492C10.4592 0.729492 13.2709 3.54116 13.2709 7.00033C13.2709 10.4595 10.4592 13.2712 7.00008 13.2712ZM7.00008 1.60449C4.02508 1.60449 1.60425 4.02533 1.60425 7.00033C1.60425 9.97533 4.02508 12.3962 7.00008 12.3962C9.97508 12.3962 12.3959 9.97533 12.3959 7.00033C12.3959 4.02533 9.97508 1.60449 7.00008 1.60449Z",
    fill: "#E60A2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8.89551C6.76083 8.89551 6.5625 8.69717 6.5625 8.45801V4.95801C6.5625 4.71884 6.76083 4.52051 7 4.52051C7.23917 4.52051 7.4375 4.71884 7.4375 4.95801V8.45801C7.4375 8.69717 7.23917 8.89551 7 8.89551Z",
    fill: "#E60A2B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00001 9.47901C6.88917 9.47901 6.77834 9.43818 6.69084 9.35068L4.94084 7.60068C4.77167 7.43151 4.77167 7.15151 4.94084 6.98234C5.11001 6.81318 5.39001 6.81318 5.55917 6.98234L7.00001 8.42318L8.44084 6.98234C8.61001 6.81318 8.89001 6.81318 9.05917 6.98234C9.22834 7.15151 9.22834 7.43151 9.05917 7.60068L7.30917 9.35068C7.22167 9.43818 7.11084 9.47901 7.00001 9.47901Z",
    fill: "#E60A2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownCircleIcon);
export default __webpack_public_path__ + "static/media/arrow-down-circle-icon.65d711b62a9f86f518b161cdc3c59c39.svg";
export { ForwardRef as ReactComponent };